import { render, staticRenderFns } from "./PT030ProductSearchParts.vue?vue&type=template&id=c10151e0&"
import script from "./PT030ProductSearchParts.vue?vue&type=script&lang=js&"
export * from "./PT030ProductSearchParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports